import { Component, Input, Output, EventEmitter} from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductViewDataService } from './../../services/product-view-data.service';
import { LoaderService } from '../../../app/services/loader.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { ContentHelper } from 'libs-content-helper';
import { ProductTocService } from './../../services/product-toc.service';
import { scoreFormatTypes } from 'modules/shared-all/constants/test.constants';
import { AuthService } from '../../../app/services/auth.service';
import { UserSettingsService } from 'modules/shared-postlogin/services/user-settings.service';

@Component({
    selector: 'learning-path',
    templateUrl: './learning-path.template.html',
    styleUrls: ['./learning-path.style.scss'],
    standalone: false
})
export class LearningPath {

  @Input() learningpathVisible : boolean = true;
  @Output() learningpathVisibleChange = new EventEmitter<boolean>();
  @Input() tocArray : any[];
  @Input() selectedItem : any;
  @Input() productMeta : any;
  @Input() bundleDetails : any;
  @Input() previewMode: string;
  @Input() previewStage:string;
  @Input() isPreviewMode: boolean;
  @Input() assignmentId: string;
  @Input() assignmentData: any;
  @Input() showComponentBackBtn: boolean = false;
  @Input() assignmentReviewMode: boolean = false;
  @Input() accessibleUnitCode: string = '';
  @Input() scoreType: 'bestScore' | 'firstScore' = 'bestScore';

  public contentHelper = ContentHelper;
  public imageBasePath: string = IMAGES_BASEPATH;

  unitView : boolean = false;
  spaceId: string;
  classId: string;
  learnerDlsId: string;
  tocFolderDepth: number = 0;
  isTestTypeComp: boolean = false;
  scoreDetailFormatTypes = {
    mock: "MOCK",
    none: "none"
  }
  productModelTypes = {
    test: 'TEST'
  }
  
  productScoreFormatType : string;
  scoreFormatTypes = scoreFormatTypes;
  
  pageSource: string;
  itemId: string;
  productCode: string;
  userRole;
  hideBackBtn: boolean = false;
  userDetails: any;
  constructor(private productViewDataService: ProductViewDataService, 
    private activatedRoute: ActivatedRoute, 
    private loaderService: LoaderService,
    private appHelperService: AppHelperService,
    private router: Router,
    private productTocService: ProductTocService,
    private authService: AuthService,
    private userSettingsService: UserSettingsService) { 
    activatedRoute.params.subscribe( params => {
      this.classId = params.classid;
      this.spaceId = params.spaceid;
      this.learnerDlsId = params.userid;
      this.productCode = params.productcode;
    })
  }
  
  ngOnInit() {
    this.tocFolderDepth = this.productTocService.getTocNodeCount(this.tocArray);
    const isShowTOCOnLaunchForFirstVisit = this.userSettingsService.getShowTOCOnLaunchForFirstVisit();
    this.productScoreFormatType = this.getScoreTypeFormat();
    if(this.tocFolderDepth === 0 || isShowTOCOnLaunchForFirstVisit){
      this.unitView = true;
    }    
    this.isTestTypeComp = this.isTestTypeComponent();
    this.userDetails = this.authService.getUserData();
    this.userRole = this.userDetails && this.userDetails.role;
    const { queryParams } = this.activatedRoute.snapshot;
    if(queryParams && queryParams.lf === 'ldl') {
      this.hideBackBtn = true;
    }
  }
  // Function to set focus on html element
  setFocusOnHtmlEle(elementId) {
    setTimeout(() => {
      const htmlElement = document.getElementById(elementId)
      if (htmlElement) {
        htmlElement.focus();
      }
    }, 0);
  }

  toggleSideBar() {
    this.learningpathVisible = !this.learningpathVisible;
    this.learningpathVisibleChange.emit(this.learningpathVisible);

    // Set focus to sidebar button when sidebar is closed
    this.setFocusOnHtmlEle('selectedActivitySidebarBtn');
  }
  launchActivity(activityItem) {
    if (activityItem['item-code'] === this.selectedItem.activityId) {
      // When the user clicks on the current activity, return
      return;
    }
    this.loaderService.showOverlayLoader();
    // Close learningPath on activity change if width lies in the range of mobile screens
    if (window.innerWidth < 576) {
      this.learningpathVisible = false;
      this.learningpathVisibleChange.emit(this.learningpathVisible);
    }
    //Fix for NPB - 258
    if (document.getElementsByClassName("activeClosed").length > 0) {
      document.getElementsByClassName("activeClosed")[0].classList.remove("activeClosed");
    }
    if(this.previewMode) {
      this.router.navigate(["item", activityItem['item-code']], {relativeTo: this.activatedRoute, queryParams : { preview: true, stage : this.previewStage}}); 
    } else {
      let requiredQueryParams = this.appHelperService.getRequiredQueryParams(this.activatedRoute.snapshot.queryParams, ['lf', 'cid', 'bcode', 'rcode', 'ltik', 'ltiGiId']);
      this.router.navigate(["item", activityItem['item-code']], {relativeTo: this.activatedRoute, queryParams: requiredQueryParams});
    }
  }  
  changeCardBgColor(event) {
    var target = event.target;
    var targetClasses = target.classList;
    var cardElementClasses = target.parentElement.parentElement.classList;
    if ( targetClasses.contains("active")) {
      if (targetClasses && targetClasses.contains("collapsed")) {
          cardElementClasses.remove("activeClosed");
       } else {
          cardElementClasses.add("activeClosed");        
       }
    }
  }
  startLoader() {
    this.loaderService.showOverlayLoader();
  }

  navigateBack() {
    if (this.activatedRoute.firstChild) {
      this.pageSource = this.activatedRoute.firstChild.snapshot.data.source;
      this.itemId = this.activatedRoute.firstChild.snapshot.params.itemid;
    }
    const bundleCode = this.activatedRoute.snapshot.data.resolveData.productData.bundleDetails['bundle-code'];
    if (this.pageSource === 'TEACHER_CEFR_REVIEW_TEST') {
      const urlOptions = {
        hashParams: {
            elem : 'cefr-review'
        }
      }
      const folderCode = this.appHelperService.getLastFolderCodeFromItemId(this.itemId);
      this.appHelperService.navigateToClassApp(['teacher', this.spaceId, 'class', this.classId, 'learner', this.learnerDlsId,
        'bundle', bundleCode, 'cefr-report', 'product', this.productCode, encodeURIComponent(folderCode)], urlOptions);
      return;
    }

    if (this.pageSource === 'LEARNER_CEFR_REVIEW_TEST') {
      const urlOptions = {
        hashParams: {
          elem: 'cefr-review'
        }
      }
      const folderCode = this.appHelperService.getLastFolderCodeFromItemId(this.itemId);
      this.appHelperService.navigateToClassApp(['learner', this.spaceId, 'class', this.classId, 'bundle', bundleCode,
        'cefr-report', 'product', this.productCode, encodeURIComponent(folderCode)], urlOptions);
      return;
    }

    const { queryParams } = this.activatedRoute.snapshot;
    if(queryParams.lf == 'ltd') {
      this.appHelperService.navigateToOnboardingApp(['lti-teacher-dashboard', this.spaceId, 'class', queryParams.cid, 'ltik', queryParams.ltik]);
    } else if(queryParams.lf == 'ltc') {
      this.appHelperService.navigateToOnboardingApp(['lti-component-selection', this.spaceId, 'class', queryParams.cid, 'bundle', queryParams.bcode, 'resource', queryParams.rcode, 'ltik', queryParams.ltik]);
    }  else if (this.assignmentId && this.isPreviewMode) {
    // if assignment and preview mode, go back to teacher assignment view
      let options;
      if (this.assignmentReviewMode && this.learnerDlsId) {
        options = {
          hashParams: {
            aid: this.assignmentId,
            sid: this.learnerDlsId
          }
        }
      }
      this.appHelperService.navigateToClassApp(['teacher', this.spaceId, 'class', this.classId, 'view/assignments'], options);
      // if only assignment, go back to learner assignment view
      // This is the only case where learner can see the back button
    } else if (this.assignmentId) {
      let options;
      if (this.assignmentReviewMode) {
        options = {
          hashParams: {
            aid: this.assignmentId,
          }
        };
      }
      this.appHelperService.navigateToClassApp(['learner', this.spaceId, 'class', this.classId, 'assignments'], options);
      // If student and not in assignment, go back to dashboard
    } else if (this.userRole === 'student') {
      this.appHelperService.navigateToDashboardApp(['learner', 'dashboard']);
    }
      // if only class id, go back to class materials page
      // this is applicable for Teacher Practice Extra view
     else if (this.classId) {
      this.appHelperService.navigateToClassApp(['teacher', this.spaceId, 'class', this.classId, 'view/materials']);
      // in any other case, go back to Bundle View
      // this is applicable for Teacher My Library
    } else {
      const bundleCode = this.bundleDetails['bundle-code'];
      this.appHelperService.navigateToDashboardApp(['teacher', this.spaceId, 'bundle', bundleCode, 'view']);
    }
  }

  // When tab is pressed on back button, focus should go to cross button
  backBtnKeydownHandler(event, crossBtn){
    if(!event.shiftKey &&  event.key === 'Tab'){
      event.preventDefault();
      this.setFocusOnHtmlEle(crossBtn);
    }
  }

// When shift+tab is pressed on cross button, focus should go to back button
  crossBtnKeydownHandler(event, backBtn){
    if(event.shiftKey &&  event.key === 'Tab'){
      this.setFocusOnHtmlEle(backBtn);
    }

  }
  
  getLessonArray() {
    if (!this.tocFolderDepth || this.selectedItem.selectedUnitIndex === undefined) {
      return;
    }
    // selectedUnitIndex is the index of item selected at first level. For 3 level, this is selected unit's index but for 2 level this is selected lesson's index.
    return this.tocFolderDepth === 1 ? this.tocArray : this.tocArray[this.selectedItem.selectedUnitIndex].items;
  }

  // Function to check test type product
  isTestTypeComponent() {
    const bundleProduct = this.bundleDetails && this.bundleDetails.products.find((product) => product['dls-product'] && this.productMeta && product['dls-product'].code === this.productMeta.productcode);
    const resultsDisplayScoreDetailFormat = bundleProduct['results-display'] && bundleProduct['results-display']['score-detail-format'] ? bundleProduct['results-display']['score-detail-format'] : this.scoreDetailFormatTypes.none;
    const productModelType = bundleProduct['ext-product'] && bundleProduct['ext-product']['model'];

    return resultsDisplayScoreDetailFormat === this.scoreDetailFormatTypes.mock || productModelType === this.productModelTypes.test;
  }

  getScoreTypeFormat() {
    let product;
    if (this.bundleDetails.products)
      product = this.bundleDetails.products.find((prod) => prod['dls-product'] && prod['dls-product'].code === this.productMeta.productcode);
    return product && product['results-display'] && product['results-display']['score-format'];
  }


  /* TO BE REMOVED IF NEMO-1277 is discarded
  public isAbsoluteUrl(url) {
    let pat = /(^https?:\/\/)|(^\/\/)/i;
    return pat.test(url);
  }*/
}
